import { TChallengeStatus, EChallengeStatus } from 'shared/types/challenges.interface';
import { TDebateStatus, EDebateStatuses } from 'shared/types/debates.interface';
import { ECardTypes } from 'shared/types/card.interface';
import { CHALLENGE_STATUSES, DEBATE_STATUSES } from 'shared/constants/statuses-constants';

type TStatusInfo = {
  text: string;
  backgroundColor: string;
  textColor: string;
};

type TCardStatuses = {
  [ECardTypes.Challenge]: {
    [M in TChallengeStatus]: TStatusInfo;
  };
  [ECardTypes.Debate]: {
    [M in TDebateStatus]: TStatusInfo;
  };
};

export const cardStatuses: TCardStatuses = {
  [ECardTypes.Challenge]: {
    [EChallengeStatus.Waiting]: {
      text: CHALLENGE_STATUSES.Waiting,
      backgroundColor: 'myColors.yellow',
      textColor: '#000000',
    },
    [EChallengeStatus.Accepted]: {
      text: CHALLENGE_STATUSES.Accepted,
      backgroundColor: 'myColors.green',
      textColor: '#000000',
    },
    [EChallengeStatus.Retracted]: {
      text: CHALLENGE_STATUSES.Retracted,
      backgroundColor: 'myColors.red',
      textColor: '#FFFFFF',
    },
    [EChallengeStatus.Expired]: {
      text: CHALLENGE_STATUSES.Expired,
      backgroundColor: 'myColors.red',
      textColor: '#FFFFFF',
    },
    [EChallengeStatus.Finished]: {
      text: CHALLENGE_STATUSES.Finished,
      backgroundColor: 'myColors.grey',
      textColor: '#FFFFFF',
    },
  },
  [ECardTypes.Debate]: {
    [EDebateStatuses.Scheduled]: {
      text: DEBATE_STATUSES.Scheduled,
      backgroundColor: 'myColors.yellow',
      textColor: '#000000',
    },
    [EDebateStatuses.InProgress]: {
      text: DEBATE_STATUSES.InProgress,
      backgroundColor: 'myColors.green',
      textColor: '#000000',
    },
    [EDebateStatuses.Failed]: {
      text: DEBATE_STATUSES.Failed,
      backgroundColor: 'myColors.red',
      textColor: '#FFFFFF',
    },
    [EDebateStatuses.Deleted]: {
      text: DEBATE_STATUSES.Deleted,
      backgroundColor: 'myColors.grey',
      textColor: '#FFFFFF',
    },
    [EDebateStatuses.Left]: {
      text: DEBATE_STATUSES.Finished,
      backgroundColor: 'myColors.grey',
      textColor: '#FFFFFF',
    },
    [EDebateStatuses.Finished]: {
      text: DEBATE_STATUSES.Finished,
      backgroundColor: 'myColors.grey',
      textColor: '#FFFFFF',
    },
  },
};
